import {
  createBrowserRouter,
  Navigate,
  RouteObject,
  RouterProvider,
} from 'react-router-dom';

import { DefaultErrorElement } from 'src/app/DefaultErrorElement';
import { NotFoundRoute } from 'src/app/NotFoundRoute';
import { ChatLayout } from 'src/features/chat/ChatLayout';
import { chatRoutes } from 'src/features/chat/routes';
import { DefaultRouteLayout } from 'src/features/dispatch';
import { dispatchRoutes } from 'src/features/dispatch/dispatcher.routes';
import { fleetRoutes } from 'src/features/fleet';
import { FleetLayout } from 'src/features/fleet/FleetLayout';
import { InvoiceLayout } from 'src/features/invoices/InvoiceLayout';
import { invoiceRoutes } from 'src/features/invoices/routes';
import { liveMapRoutes } from 'src/features/live-map';
import { passengerRoutes } from 'src/features/passenger';
import { PassengerLayout } from 'src/features/passenger/PassengerLayout';
import { PayerLayout } from 'src/features/payer/PayerLayout';
import { payerRoutes } from 'src/features/payer/routes';
import { PricingModelLayout } from 'src/features/pricingModel/PricingModelLayout';
import { pricingModelRoutes } from 'src/features/pricingModel/routes';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';
import { settingsRoutes } from 'src/features/settings/routes';
import { SettingsLayout } from 'src/features/settings/SettingsLayout';
import { rideOrderingPortalTeamRoutes, teamRoutes } from 'src/features/team';
import { TeamLayout } from 'src/features/team/TeamLayout';
import {
  rideOrderingPortalTripRoutes,
  tripRoutes,
} from 'src/features/trip/routes';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/dispatch" />,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/dispatch',
    element: <DefaultRouteLayout />,
    children: dispatchRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/live-map',
    element: <DefaultRouteLayout />,
    children: liveMapRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/team/*',
    element: <TeamLayout />,
    children: teamRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/fleet/*',
    element: <FleetLayout />,
    children: fleetRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/passengers/*',
    element: <PassengerLayout />,
    children: passengerRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/trips/*',
    element: <DefaultRouteLayout />,
    children: tripRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/payers/*',
    element: <PayerLayout />,
    children: payerRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/pricing/pricing-models/*',
    element: <PricingModelLayout />,
    children: pricingModelRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/settings/*',
    element: <SettingsLayout />,
    children: settingsRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/chat/*',
    element: <ChatLayout />,
    children: chatRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/invoices/*',
    element: <InvoiceLayout />,
    children: invoiceRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '*',
    element: <NotFoundRoute />,
    errorElement: <DefaultErrorElement />,
  },
];

export const rideOrderingPortalRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/trips" />,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/live-map',
    element: <DefaultRouteLayout />,
    children: liveMapRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/team/*',
    element: <TeamLayout />,
    children: rideOrderingPortalTeamRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/passengers/*',
    element: <PassengerLayout />,
    children: passengerRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '/trips/*',
    element: <DefaultRouteLayout />,
    children: rideOrderingPortalTripRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '*',
    element: <NotFoundRoute />,
    errorElement: <DefaultErrorElement />,
  },
];

export function Routing() {
  const shouldUseRideOrderingPortalRoutes =
    useShouldShowRideOrderingPortalFeatures();
  const router = createBrowserRouter(
    shouldUseRideOrderingPortalRoutes ? rideOrderingPortalRoutes : routes
  );
  return <RouterProvider router={router} />;
}
